import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output,
  viewChild,
} from '@angular/core';
import {
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-datepicker',
  templateUrl: './form-datepicker.component.html',
  styleUrls: ['./form-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    DatePickerModule,
    ButtonModule,
    RippleModule,
  ],
})
export class FormDatepickerComponent implements OnInit {
  readonly showCalendar = input<boolean>(false, { alias: 'visible' });
  readonly form = input.required<UntypedFormGroup>();
  readonly dateRange = input<any>();

  readonly selectedDate = output<any>();
  readonly selectedForm = output<any>();
  readonly hideCalenderPopup = output<boolean>({ alias: 'hideCalender' });

  timePeriodDate: Date[] | any;

  constructor() {}

  ngOnInit(): void {
    this.timePeriodDate = this.dateRange();
  }

  private readonly calendar = viewChild<any>('calendar');
  onDateSelect() {
    if (this.timePeriodDate?.[1]) {
      setTimeout(() => {
        this.selectedDate.emit({
          dateObject: this.timePeriodDate,
          form: this.form(),
        });
        this.hideCalenderPopup.emit(false);
      }, 1000);
    }
  }

  SetDate() {
    if (this.timePeriodDate?.[1]) {
      this.selectedDate.emit({
        dateObject: this.timePeriodDate,
        form: this.form(),
      });
      this.hideCalenderPopup.emit(false);
    }
  }

  ClosePopup() {
    this.hideCalenderPopup.emit(false);
  }

  closeDialog() {
    this.ClosePopup();
  }
}
